<ng-container *ngIf="isMobile; else desktopLayout">
  <section class="menu-navigation-banner-mobile" [appStoryblokEditable]="thematicResources._editable">
    <h2 class="menu-navigation-banner-mobile__title">{{ thematicResources.title }}</h2>
    <div>
      <ul class="menu-navigation-banner-mobile__link-list">
        <li *ngFor="let thematicResource of thematicResources.thematicresource">
          <app-mobile-menu-item
            [linkText]="thematicResource.text"
            [link]="thematicResource.link"
            (onClick)="onNavigate($event); onLinkClick()"
            [appStoryblokEditable]="thematicResource._editable"
          >
          </app-mobile-menu-item>
        </li>
      </ul>
    </div>
  </section>
</ng-container>

<ng-template #desktopLayout>
  <section class="menu-navigation-banner-desktop" [appStoryblokEditable]="thematicResources._editable">
    <h2 class="menu-navigation-banner-desktop__title">
      {{ thematicResources.title }}
    </h2>
    <div class="menu-navigation-banner-desktop__banner-container">
      <div
        class="menu-navigation-banner-desktop__banner-container__item"
        *ngFor="let thematicResource of thematicResources.thematicresource"
        [appStoryblokEditable]="thematicResource._editable"
      >
        <a
          class="menu-navigation-banner-desktop__banner-container__item__image-anchor"
          (click)="onNavigate(thematicResource.link); onLinkClick()"
          appDisableClickEvent
        >
          <img [src]="getImageSrc(thematicResource.desktop)" />
        </a>
        <a
          class="menu-navigation-banner-desktop__banner-container__item__banner-text"
          (click)="onNavigate(thematicResource.link); onLinkClick()"
          appDisableClickEvent
        >
          {{ thematicResource.text }}
          <span class="menu-navigation-banner-desktop__banner-container__item__banner-text__arrow">
            <mm-icon name="chevron-right"></mm-icon>
          </span>
        </a>
        <p class="menu-navigation-banner-desktop__banner-container__item__banner-subtext">
          {{ thematicResource.subtext }}
        </p>
      </div>
    </div>
  </section>
</ng-template>
